export default function diagramBrushInit(fabric) {
  fabric.DiagramBrush = fabric.util.createClass(fabric.BaseBrush, {
    // 鼠标按下
    _isMouseDown: false,
    // 起始 x
    originX: 0,
    // 起始 y
    originY: 0,
    // 当前物件
    curObject: null,
    initialize(canvas, options) {
      if (!canvas) {
        return
      }
      this.canvas = canvas
      this.options = options
      // 开启画图模式
      this.canvas.isDrawingMode = true
    },
    async onMouseDown(pointer) {
      console.log('onMouseDown')
      this._isMouseDown = true
      const { x, y } = pointer
      this.originX = x
      this.originY = y
      const curObject = await this.options.getObject(this, pointer)
      if (curObject) {
        this.curObject = curObject
        this.canvas.add(curObject)
      }
      const { afterAdd } = this.options
      if (afterAdd) {
        afterAdd(this)
      }
    },
    onMouseMove(pointer) {
      if (!this._isMouseDown) {
        return
      }
      this.options.renderMove(this, pointer)
      this.canvas.renderAll()
    },
    onMouseUp(event) {
      this._isMouseDown = false
      // 如果改变了 object 的 size 需要执行这个方法
      if (this.curObject) {
        this.curObject.setCoords()
      }
      const { afterMouseUp } = this.options
      if (afterMouseUp) {
        afterMouseUp(this)
      }
    }
  })
}